const columns = {
  salutation: { id: "salutation", name: "Title", sortable: false, deselectable: true },
  forename: { id: "forename", name: "Forename", sortable: true, deselectable: false },
  surname: { id: "surname", name: "Surname", sortable: true, deselectable: false },
  display_name: { id: "display_name", name: "Display Name", sortable: false, deselectable: true },
  email: { id: "email", name: "Email", sortable: false, deselectable: true },
  sb_account_email: { id: "sb_account_email", name: "SB Account Email", sortable: false, deselectable: false },
  is_teacher: { id: "is_teacher", name: "Teacher", sortable: false, deselectable: true },
  reg_group: { id: "reg_group", name: "Reg Group", sortable: false, deselectable: true },
  local_id: { id: "local_id", name: "MIS ID", sortable: false, deselectable: true },
  user_id: { id: "user_id", name: "User ID", sortable: false, deselectable: true },
  data_ref: { id: "data_ref", name: "Xporter ID", sortable: false, deselectable: true },
  is_sync: { id: "is_sync", name: "Type", sortable: false, deselectable: true },
  no_of_lessons: { id: "no_of_lessons", name: "# Lessons", sortable: false, deselectable: true },
  created_at: { id: "created_at", name: "Created", sortable: false, deselectable: true },
  updated_at: { id: "updated_at", name: "Updated", sortable: false, deselectable: true },
  actions: { id: "actions", name: "Actions", sortable: false, deselectable: false },
}

const defaultColumns = [
  "salutation",
  "forename",
  "surname",
  "sb_account_email",
  "is_teacher",
  "local_id",
  "is_sync",
  "no_of_lessons",
  "created_at",
  "updated_at",
  "actions",
]

const downloadOptions = [{ key: "xls", name: "Download All XLS" }]

const filters = {
  custom: { id: "custom", name: "Custom" },
  sync: { id: "sync", name: "Sync" },
  isTeacher: { id: "isTeacher", name: "Is Teacher" },
  isNotTeacher: { id: "isNotTeacher", name: "Is Not Teacher" },
}

export { columns, defaultColumns, downloadOptions, filters }
